<mat-form-field floatLabel="auto" class="col-12" subscriptSizing="dynamic">
  <mat-label>
    {{ schema.title }}
  </mat-label>
  @if (schema.examples) {
    <mat-select
      [formControl]="aFormControl"
      [multiple]="schema[SchemaKeywords.Multiple] === true"
      (selectionChange)="onSelectionChange($event)"
    >
      @for (example of schema.examples; track example['value']) {
        <mat-option
          [value]="example['value']"
          [matTooltip]="example?.['description']"
          [disabled]="example?.['_ui_disable'] === true"
        >
          {{example?.['label']}}
        </mat-option>
      }
    </mat-select>
  } @else {
    <mat-select
      [formControl]="aFormControl"
      [multiple]="schema[SchemaKeywords.Multiple] === true"
      [(value)]="aFormControl.value"
      (selectionChange)="onSelectionChange($event)"
    >
      @for (value of schema.enum; track value) {
        <mat-option [value]="value">
          {{value}}
        </mat-option>
      }
    </mat-select>
  }
  @if (schema.description) {
    <mat-hint>{{ schema.description }}</mat-hint>
  }
</mat-form-field>
